<script setup>
import { __, decodeHTMLEntities } from '@/utils';

// defineProps(['data']) 

const props = defineProps({
    data: Object,
});

const isActive = window.location.pathname.includes('/account');

const setStroke = (isActive, target) => isActive ? `url(#${target})` : '#000';
</script>

<template>
    <div class="account-badge">
        <div class="account-badge__icon"> 
            <img :src="`${theme_path.url}/resources/images/svg/icon-profile-icon.svg`" width="24" height="21.94" alt="">
        </div>
        <p class="account-badge__name">{{ __('Hi') }} {{data.first_name}}</p>

        <div class="account-badge-dropdown">
            <div class="account-badge-dropdown__icon no-image">
                <img :src="`${theme_path.url}/resources/images/svg/icon-profile-large-icon.svg`" width="38.93" height="35.6" alt="">
                <!-- <button type="button" class="account-badge-dropdown__upload">
                    <img :src="theme_path.url + '/resources/images/svg/icon-upload.svg'" alt="">
                </button> -->
            </div>
            <h4 class="account-badge-dropdown__name">{{ decodeHTMLEntities(data.first_name) }} {{ decodeHTMLEntities(data.last_name) }}</h4>
            <ul>
                <li>
                    <a href="/account">
                        <div class="account-badge__nav-icon">
                            <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M24.8127 6.0886L24.8125 6.08865L16.8382 8.36688L20.315 1.4154L20.315 1.41529C20.3779 1.28962 20.5414 1.23655 20.6719 1.31247C22.4794 2.36506 23.9704 3.89842 24.9713 5.739L24.9716 5.73955C25.0364 5.85862 24.9759 6.04199 24.8127 6.0886Z"
                                    :stroke="setStroke(isActive, 'paint0_linear_2840_82322')"
                                    stroke-width="2"
                                />
                                <path
                                    d="M11.4403 1.04311V11.1964C11.4403 12.4353 12.4454 13.4404 13.6844 13.4404H23.8376C23.322 19.3959 18.2437 24.0453 12.1159 23.8762C6.15515 23.7117 1.17018 18.7268 1.00454 12.7659C0.834322 6.63823 5.48472 1.55889 11.4403 1.04311Z"
                                    :stroke="setStroke(isActive, 'paint1_linear_2840_82322')"
                                    stroke-width="2"
                                />
                                <defs v-if="isActive">
                                    <linearGradient id="paint0_linear_2840_82322" x1="15.3437" y1="4.98131" x2="25.9985" y2="4.98131" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#50C8EE"/>
                                        <stop offset="1" stop-color="#463C96"/>
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_2840_82322" x1="-0.000219933" y1="12.4409" x2="24.8805" y2="12.4409" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#50C8EE"/>
                                        <stop offset="1" stop-color="#463C96"/>
                                    </linearGradient>
                                </defs>
                            </svg>

                        </div>
                        {{ __('main') }}
                    </a>
                </li>
                <li>
                    <a href="/wp-json/custom/v1/logout">
                        <div class="account-badge__nav-icon">
                            <img :src="theme_path.url + '/resources/images/svg/icon-logout.svg'" alt="" />
                        </div>
                        {{ __('disconnection') }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>